import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class RoadmapStrategyRoadmapLensController extends Controller {
  initiativeOptions = [];

  @action
  updateSelectedInitiatives() {}

  @action
  removeInitiative() {}

  get scenario() {
    return this.model?.['investment-scenario'];
  }
}
